import { useMemo } from "react"
import Dialog from "@mui/material/Dialog"
import Button from "@mui/material/Button"
import DevicesOutlinedIcon from "@mui/icons-material/DevicesOutlined"
import CleaningServicesOutlinedIcon from "@mui/icons-material/CleaningServicesOutlined"
import { useAuthContext } from "./context/AuthContext"
import { localInventory } from "./utils/local-inventory"

const bulletRow = {
  display: "flex",
  alignItems: "flex-start",
  gap: 10,
  fontSize: 12.5,
  color: "var(--muted)",
  lineHeight: 1.45,
}

const bulletIcon = {
  fontSize: 16,
  color: "var(--accent)",
  marginTop: 1,
  flexShrink: 0,
}

export const MigrationDialog = () => {
  const authCtx = useAuthContext()

  const cardCount = useMemo(() => {
    if (!authCtx.migrationNeeded) {
      return 0
    }
    const local = localInventory.load()
    return local
      ? Object.values(local).filter((count) => count > 0).length
      : 0
  }, [authCtx.migrationNeeded])

  return (
    <Dialog
      open={authCtx.migrationNeeded}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: "var(--surface-2)",
          border: "1px solid var(--border)",
          backgroundImage: "none",
        },
      }}
    >
      <div style={{ padding: "20px 24px 24px" }}>
        <div
          style={{
            fontSize: 15,
            fontWeight: 600,
            color: "var(--text)",
            marginBottom: 10,
          }}
        >
          Save this collection to your account?
        </div>

        <p style={{ fontSize: 13, color: "var(--text)", margin: "0 0 14px" }}>
          This device has a collection with{" "}
          <b>
            {cardCount} {cardCount === 1 ? "card" : "cards"}
          </b>{" "}
          saved outside your account.
        </p>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
            margin: "0 0 18px",
          }}
        >
          <div style={bulletRow}>
            <DevicesOutlinedIcon sx={bulletIcon} />
            <span>Saving makes it available on all your devices.</span>
          </div>
          <div style={bulletRow}>
            <CleaningServicesOutlinedIcon sx={bulletIcon} />
            <span>
              Your account becomes the only copy — collections left on other
              devices are cleared when you log in there.
            </span>
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <Button
            variant="contained"
            disableElevation
            onClick={() => authCtx.resolveMigration("import")}
          >
            Save to account
          </Button>
          <div style={{ display: "flex", gap: 8 }}>
            <Button
              variant="outlined"
              style={{ flex: 1 }}
              onClick={() => authCtx.resolveMigration("later")}
            >
              Not now
            </Button>
            <Button
              variant="outlined"
              style={{ flex: 1 }}
              onClick={() => authCtx.resolveMigration("never")}
            >
              Never ask again
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  )
}
